import React, { Component } from 'react'
import { connect } from 'dva'
import { Table, Row, Col, Tooltip, DatePicker } from 'antd'
import { ExportOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import './styles.less'
import moment from 'moment'
import Config from '../../config/Config'
import { getToken } from '../../utils/authority'
import qs from 'query-string'

import BasicLayout from '../../components/BasicLayout'
import { routerRedux } from 'dva/router'
import { formatDateByGranularity } from '../../utils/dateFormat'
import { METRIC_TIPS } from '../../constants/metricTips'


class GameList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      catalogSelected: [
        { value: [] },
        { value: null },
        { value: [] },
        { value: [] },
        { value: null },
        { value: 'all' },
        { value: '0' }
      ],
      search: {
        dateType: 0,
        date: moment().format('YYYY-MM-DD'),
      },
      dateList: [moment().subtract(2, 'days').format('YYYY-MM-DD'), moment().subtract(1, 'days').format('YYYY-MM-DD')],
      dateIndex: 0,
      showMore: false,
    }
  }

  // 生成筛选器目录配置（动态生成）
  getCatalog = () => {
    const { segmentList = [], genreList = [] } = this.props
    return [
      {
        nameEN: 'Platform',
        nameCN: '流媒体网站',
        list: [
          { nameEN: 'DouYu', value: '103' },
          { nameEN: 'HuYa', value: '102' },
          { nameEN: 'Bilibili', value: '101' },
        ]
      },
      {
        nameEN: 'Publisher',
        nameCN: '经营者',
        list: [
          { nameEN: 'Tencent', value: 'Tencent' },
          { nameEN: 'NetEase', value: 'Netease' },
          { nameEN: 'Steam', value: 'Steam' },
          { nameEN: 'miHoYo', value: 'Mihoyo Game' },
          { nameEN: 'EA', value: 'EA' },
          { nameEN: 'Ubisoft', value: 'Ubisoft' },
          { nameEN: 'Perfect World', value: 'Perfect World' },
          { nameEN: 'Nexon', value: 'Nexon' },
          { nameEN: 'Blizzard', value: 'Blizzard' },
          { nameEN: 'SCE', value: 'SCE' },
          { nameEN: 'Nintendo', value: 'Nintendo' },
          { nameEN: 'Shengqu', value: 'Shengqu' },
          { nameEN: '37 Game', value: '37 Game' },
          { nameEN: '4399 Game', value: '4399 Game' },
          { nameEN: 'Leiting Game', value: 'Leiting Game' },
          { nameEN: 'Activison', value: 'Activison' },
          { nameEN: 'Take-Two', value: 'Take-Two' },
          { nameEN: 'Bilibili', value: 'Bilibili' },
          { nameEN: 'Other', value: 'other' },
        ]
      },
      {
        nameEN: 'Game Platform',
        nameCN: '平台',
        list: [
          ...(segmentList || []).map(segment => ({
            nameEN: segment.name,
            value: segment.id
          }))
        ]
      },
      {
        nameEN: 'Genre',
        nameCN: '类型',
        list: [
          ...(genreList || []).map(genre => ({
            nameEN: genre.name,
            value: genre.id
          }))
        ]
      },
      {
        nameEN: 'Developer',
        nameCN: '发展商',
        list: [
          { nameEN: 'Tencent', value: 615 },
          { nameEN: 'NetEase', value: 617 },
          { nameEN: 'Steam', value: 616 },
          { nameEN: 'miHoYo', value: 627 },
          { nameEN: 'EA', value: 622 },
          { nameEN: 'Ubisoft', value: 690 },
          { nameEN: 'Perfect World', value: 618 },
          { nameEN: 'Nexon', value: 766 },
          { nameEN: 'Blizzard', value: 621 },
          { nameEN: 'SCE', value: 653 },
          { nameEN: 'Nintendo', value: 647 },
          { nameEN: 'Shengqu', value: 623 },
          { nameEN: '37 Game', value: 686 },
          { nameEN: '4399 Game', value: 752 },
          { nameEN: 'Leiting Game', value: 691 },
          { nameEN: 'Activison', value: 1065 },
          { nameEN: 'Take-Two', value: 790 },
          { nameEN: 'Bilibili', value: 631 },
          { nameEN: 'Other', value: 'other' },
        ]
      },
      {
        nameEN: 'Licensing Status',
        nameCN: '注册许可',
        list: [
          { nameEN: 'Licensed', nameCN: '已注册', value: 'licensed' },
          { nameEN: 'Unlicensed', nameCN: '未注册', value: 'unlicensed' }
        ]
      },
      {
        nameEN: 'Timeframe',
        nameCN: '时间段',
        list: [
          { nameEN: 'Daily', nameCN: '昨天', value: '0' },
          { nameEN: 'Weekly', nameCN: '周', value: '1' },
          { nameEN: 'Monthly', nameCN: '月度', value: '2' },
          { nameEN: 'Quarterly', nameCN: '季度', value: '3' },
          { nameEN: 'Yearly', nameCN: '年度', value: '4' }
        ]
      },
    ]
  }

  componentDidMount() {
    const { search } = this.state
    this.props.dispatch({
      type: 'gameList/apiGetAllMetrics',
      payload: {
        page: 1,
        perPage: 10,
        ...search
      }
    })
    this.props.dispatch({
      type: 'gameList/apiGetSegments'
    })
    this.props.dispatch({
      type: 'gameList/apiGetGenres'
    })
  }

  componentWillReceiveProps(nextProps, nextContext) {
  }

  handleDateChange = async (dateIndex) => {
    dateIndex = parseInt(dateIndex)
    let date
    switch (dateIndex) {
      case 0:
        return date = moment().format('YYYY-MM-DD')
      case 1:
        return date = moment().format('YYYY-WW')
      case 2:
        return date = moment().format('YYYY-MM')
      case 3:
        return date = moment().format('YYYY-') + "Q" + moment().format('Q')
      case 4:
        return date = moment().format('YYYY')
      default:
        break;
    }
  }
  handleLastDateChange = async (dateIndex) => {
    dateIndex = parseInt(dateIndex)
    let date
    switch (dateIndex) {
      case 0:
        return date = moment().subtract(1, 'days').format('YYYY-MM-DD')
      case 1:
        return date = moment().subtract(1, 'weeks').format('YYYY-WW')
      case 2:
        return date = moment().subtract(1, 'months').format('YYYY-MM')
      case 3:
        return date = moment().format('YYYY-') + "Q" + moment().subtract(1, 'quarters').format('Q')
      case 4:
        return date = moment().subtract(1, 'years').format('YYYY')
      default:
        break;
    }
  }
  async UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
    const { catalogSelected } = this.state
    if (catalogSelected !== nextState.catalogSelected && nextState.catalogSelected) {
      let payload = {}
      payload.platformID = nextState.catalogSelected[0].value.length !== 0 ? nextState.catalogSelected[0].value.map((vo) => { return vo }).join(',') : null
      payload.Operator = nextState.catalogSelected[1].value || null
      payload.Platform = nextState.catalogSelected[2].value.length !== 0 ? nextState.catalogSelected[2].value.map((vo) => { return vo }).join(',') : null
      payload.gameGenre = nextState.catalogSelected[3].value.length !== 0 ? nextState.catalogSelected[3].value.map((vo) => { return vo }).join(',') : null
      payload.DeveloperID = nextState.catalogSelected[4].value != null && nextState.catalogSelected[4].value !== '' ? nextState.catalogSelected[4].value : null
      if (nextState.catalogSelected[5].value && nextState.catalogSelected[5].value !== 'all') {
        payload.licensed = nextState.catalogSelected[5].value
      }
      payload.dateType = nextState.catalogSelected[6].value
      let datecount = parseInt(nextState.catalogSelected[6].value)
      payload.date = await this.handleDateChange(datecount)
      payload.lastDate = await this.handleLastDateChange(datecount)
      switch (datecount) {
        case 0:
          payload.lastDate = moment(payload.date).subtract(2, 'days').format('YYYY-MM-DD')
          payload.date = moment(payload.date).subtract(1, 'days').format('YYYY-MM-DD')
          break;
        case 1:
          payload.date = payload.date + 'W'
          const dateStr = payload.date;
          const lastDigit = parseInt(dateStr[6]) || 0;
          const newDigit = lastDigit > 0 ? lastDigit - 1 : 0;
          const newDateStr = dateStr.slice(0, 6) + newDigit;
          payload.lastDate = newDateStr + 'W'
          break;
        case 2:
          payload.date = moment(payload.date).format('YYYY-MM')
          payload.lastDate = moment(payload.date).subtract(1, 'months').format('YYYY-MM')
          break;
        case 3:
          payload.date = payload.date
          const dateStr1 = payload.date; // e.g. "2026-Q1"
          const year1 = parseInt(dateStr1.slice(0, 4), 10);
          const quarter1 = parseInt(dateStr1[6], 10) || 1; // Q digit at index 6
          if (quarter1 === 1) {
            payload.lastDate = `${year1 - 1}-Q4`;
          } else {
            payload.lastDate = `${year1}-Q${quarter1 - 1}`;
          }
          break;
        case 4:
          payload.date = moment(payload.date).format('YYYY')
          payload.lastDate = moment(payload.date).subtract(1, 'years').format('YYYY')
          break;
        default:
          payload.lastDate = moment().subtract(2, 'days').format('YYYY-MM-DD')
          payload.date = moment().subtract(1, 'days').format('YYYY-MM-DD')
          break;
      }
      this.setState({
        search: payload,
        dateList: [payload.lastDate, payload.date].concat(),
        dateIndex: parseInt(payload.dateType)
      })
      this.props.dispatch({
        type: 'gameList/apiGetAllMetrics',
        payload: { ...payload }
      })
    }
  }

  handleSelectCatalog = (item, index) => {
    const { catalogSelected } = this.state
    // index 1: Publisher, index 4: Developer, index 5: Licensed, index 6: Time Period 为单选
    if (index === 1 || index === 4 || index === 5 || index === 6 || index === catalogSelected.length - 1) {
      if (index === 1 && item === 'other') {
        this.props.dispatch(routerRedux.push('/company'))
        return
      }
      if (index === 4 && item === 'other') {
        this.props.dispatch(routerRedux.push('/developer'))
        return
      }
      if (catalogSelected[index].value === item) {
        catalogSelected[index].value = null
        return
      }
      catalogSelected[index].value = item
    } else {
      let key = catalogSelected[index].value.indexOf(item)
      if (key < 0) {
        if (!item) {
          catalogSelected[index].value = []
        } else {
          catalogSelected[index].value.push(item)
        }
      } else {
        catalogSelected[index].value.splice(key, 1)
      }
    }
    this.setState({ catalogSelected: catalogSelected.concat() })
  }
  handleTableChange = (pagination, filters, sorter) => {
    const { search } = this.state
    this.props.dispatch({
      type: 'gameList/apiGetAllMetrics',
      payload: { page: pagination.current, perPage: pagination.pageSize, ...search }
    })
  }
  disabledDate(current) {
    if (current) {
      return current > moment().endOf('day') || current<moment('2020-07').endOf('day');
    }
  }
  renderTable = () => {
    const { search, dateList } = this.state
    const { metricslist, page, perPage, locale, pageLoading } = this.props
    const pagination = {
      current: parseInt(page) || 0,
      total: (metricslist || {}).total || 0,
      defaultCurrent: 1,
      defaultPageSize: parseInt(perPage) || 0,
      pageSize: perPage,
      showQuickJumper: true,
      position: 'bottom',
    }
    const { dateIndex } = this.state
    const granularity = String(dateIndex)
    const columns = [
      {
        title: <div className={'cate_header'}>{locale === 'EN' ? 'Date' : '日期'}</div>,
        dataIndex: 'date',
        key: 'date',
        render: (record) => {
          const formatted = record ? formatDateByGranularity(record, granularity) : ''
          return (
            <div className="custom_txt">{formatted}</div>
          )
        }
      },
      {
        title: <div id={'header'} className={`cate_header cate_selected`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumAnchor}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Live Streamers' : '主播数量'}
          </div>
        </div>,
        key: 'sumAnchor',
        dataIndex: 'sumAnchor',
        width: '10%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}>{record && (record).toLocaleString()}</div>
          )
        }
      },
      {
        title: <div className={`cate_header cate_selected`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumLenth}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Hours Streamed' : '主播时长'}
          </div>
        </div>,
        key: 'sumLenth',
        dataIndex: 'sumLenth',
        width: '12.4%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}>{record && (record).toLocaleString()}</div>
          )
        }
      },
      {
        title: <div className={`cate_header cate_selected`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumFans}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Subscribers' : '游戏粉丝数'}
          </div>
        </div>,
        key: 'sumFans',
        dataIndex: 'sumFans',
        width: '12.4%',
        align: 'right',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}>{record && (record).toLocaleString()}</div>
          )
        }
      },
      {
        title: <div className={`cate_header cate_selected`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumGift}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Tips' : '游戏打赏收入'}
          </div>
        </div>,
        key: 'sumGift',
        dataIndex: 'sumGift',
        width: '10%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}> {record && (record).toLocaleString()}</div>
          )
        }
      },
      {
        title: <div className={`cate_header cate_selected`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumHot}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Heat Index' : '游戏热力值'}
          </div>
        </div>,
        key: 'sumHot',
        dataIndex: 'sumHot',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}>{record && (record).toLocaleString()}</div>
          )
        }
      },
      {
        title: <div className={`cate_header cate_selected`}>
          <div className="title_name">
            <Tooltip overlayClassName="tooltip" className="text_icon" title={METRIC_TIPS.sumNiko}>
              <QuestionCircleOutlined />
            </Tooltip>
            {locale === 'EN' ? 'Niko Index' : 'Niko指数'}
          </div>
        </div>,
        key: 'sumNiko',
        dataIndex: 'sumNiko',
        width: '12.4%',
        align: 'right',
        render: (record, text) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}>{record && (record).toLocaleString()}</div>
          )
        }
      },
      {
        title: <div className={'cate_header'}>{locale === 'EN' ? 'Total Games' : '游戏数量'}</div>,
        dataIndex: 'TotalGames',
        key: 'TotalGames',
        align: 'right',
        width: '10%',
        render: (record, row, index) => {
          return (
            <div className="custom_txt" style={{ color: '#F4791F' }}>{record && record.toLocaleString()}</div>
          )
        }
      },
    ]
    return (
      <Table
        loading={pageLoading}
        dataSource={(metricslist || {}).data || []}
        columns={columns}
        rowKey={record => record.date}
        bordered={true}
        pagination={pagination}
        onChange={this.handleTableChange}
      />
    )
  }
  handleReset = () => {
    this.setState({
      catalogSelected: [
        { value: [] },
        { value: null },
        { value: [] },
        { value: [] },
        { value: null },
        { value: 'all' },
        { value: '0' },
      ],
      search: {
      },
      showMore: false,
    })
  }

  handleExport = () => {
    const { userInfo } = this.props
    if (userInfo && userInfo.status !== 'test' && userInfo.status !== 'off') {
      const { search } = this.state
      for (let index in search) {
        if (!search[index]) {
          delete search[index]
        }
      }
      window.open(`${Config.SERVER_HOME}downloadAllMetrics?WebAuth=${getToken()}&${qs.stringify(search)}`)
      this.props.dispatch({
        type: 'user/apiPostDownloadFiles',
        payload: { userID: parseInt(userInfo.id), fileID: 11 }
      })
    } else {
      this.props.dispatch({ type: 'user/setState', payload: { forbidDownload: true } })
    }
  }

  render() {
    const { locale } = this.props
    const { catalogSelected, showMore } = this.state
    const catalog = this.getCatalog()
    return (
      <BasicLayout selectedKeys={['/allmetrics']}>
        <div className="top_list">
          <div className="top_search">
            <Row>
              {catalog.map((vo, index) => {
                return (
                  <Col key={index} span={24}>
                    <div className="item_line">
                      <div className="title">{locale === 'EN' ? vo.nameEN : vo.nameCN}</div>
                      <div className="button_content">
                        {vo.list.map((item, key) => {
                          // 控制显示数量
                          if (!showMore && key >= 7) {
                            return null
                          }
                          return (
                            <div key={key} style={{ cursor: 'pointer' }}
                              className={`button ${(index === 1 || index === 4 || index === 5 || index === 6 || index === catalogSelected.length - 1) ? (catalogSelected[index].value === item.value ? 'button_activity' : null) : (catalogSelected[index].value.indexOf(item.value) >= 0 || (!catalogSelected[index].value[0] && !item.value) ? 'button_activity' : null)}`}
                              onClick={() => { this.handleSelectCatalog(item.value, index) }}
                            >{locale === 'EN' ? item.nameEN : (item.nameCN ? item.nameCN : item.nameEN)}</div>
                          )
                        })}
                        {vo.list.length > 7 ? <div className={'button more'}>
                          <span onClick={() => { this.setState({ showMore: !this.state.showMore }) }}>
                            {!showMore ? (locale === 'EN' ? 'Expand' : '展开') : (locale === 'EN' ? 'Collapse' : '收起')}
                          </span>
                        </div> : null}
                      </div>
                    </div>
                  </Col>
                )
              })}
            </Row>
          </div>
          <div className="export">
            <div style={{ marginRight: 15, cursor: 'pointer' }} className="reset_button" onClick={() => { this.handleReset() }}>{locale === 'EN' ? 'Reset' : '重置'}</div>
            <div style={{ cursor: 'pointer' }} className="export_button" onClick={() => { this.handleExport() }}><ExportOutlined className="icon" />{locale === 'EN' ? 'Export Data' : '导出'}</div>
          </div>
          {this.renderTable()}
        </div>
      </BasicLayout>
    )
  }
}

export default connect(({ gameList, user }) => ({
  metricslist: gameList.metricslist,
  page: gameList.page,
  perPage: gameList.perPage,
  pageLoading: gameList.pageLoading,
  segmentList: gameList.segmentList,
  genreList: gameList.genreList,
  userInfo: user.userInfo,
  locale: user.locale
}))(GameList)